import React, { useMemo } from "react";
import TextFiledWithLabel from "./TextFieldWithLabel";
import { isValidPhoneNumber } from "../Utility/apiHelper";
import { handleValidateCodevalue } from "../Utility/constant";
import { useSelector } from "react-redux";

const NumericTextField = ({maxLength=10, name,isDetailPage = false,isViewMode,label,value = "",handleOnChange,isRequired = false,...otherProps}) => {

  const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);

  const onInput = (e) => {
  const sanitized = e.target.value.replace(/\D/g, "");
  e.target.value = sanitized;
  };


  //To show error if input is inValid.
  const isInvalid = useMemo(() => {
    if (!value) return isRequired;
    return !isValidPhoneNumber(value);
  }, [value, isRequired]);

  return (
    <TextFiledWithLabel
      name={name}
      isViewMode={isViewMode}
      label={label || handleValidateCodevalue(internationalise, "COMMON_PHONE_NUMBER")}
      value={value}
      handleOnChange={handleOnChange}
      inputProps={{
        inputMode: "numeric",
        maxLength: maxLength,
        pattern: "[0-9]*",
        onInput: onInput
      }}
      error={isDetailPage && isInvalid}
      helperText={(isDetailPage && isInvalid) ? handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_PHONE") : undefined}
      {...otherProps}
    />
  );
};

export default NumericTextField;
